import { getAppHost, getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'

// List AI Agents
export const list = async (app, appSettings, paginationPayload = '', searchQuery = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/agent-builder/agents`

    // Build query parameters
    let queryParams = 'limit=6'
    
    // Add search query if provided
    if (searchQuery && searchQuery.trim()) {
      queryParams += `&search=${encodeURIComponent(searchQuery.trim())}`
    }
    
    // Add pagination parameters
    if (paginationPayload) {
      queryParams += `&${paginationPayload}`
    }

    // Add cache-busting param to avoid browser returning cached responses
    queryParams += `&_t=${Date.now()}`
    const url = `${baseURL}?${queryParams}`

    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
        'Cache-Control': 'no-cache',
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// Get single AI Agent
export const get = async (app, appSettings, agentId) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}`

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add AI Agent
export const add = async (app, appSettings, agentData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/agent-builder/agents`

    const response = await axios.post(baseURL, agentData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Update AI Agent
export const update = async (app, appSettings, agentId, agentData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}`

    const response = await axios.patch(baseURL, agentData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Delete AI Agent
export const remove = async (app, appSettings, agentId) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}`

    const response = await axios.delete(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Search AI Tools
export const searchTools = async (app, appSettings, agentUid, query = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentUid}/tools/search`

    const params = new URLSearchParams()
    if (query) params.append('key', query)

    const url = params.toString() ? `${baseURL}?${params.toString()}` : baseURL

    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
